import {Component, OnInit} from '@angular/core';
import {CommonFunctions} from '../../helpers/core/common.functions';
import {HttpRequests} from '../../helpers/core/http.requests';
import {RequestUrls} from '../../helpers/routes/request.urls';
import {Router} from '@angular/router';
import {DataSharing} from '../../helpers/core/data.sharing';

@Component({
    selector: 'app-authenticated',
    templateUrl: './authenticated.component.html'
})
export class AuthenticatedComponent implements OnInit {

    constructor(private c_f: CommonFunctions, private h_r: HttpRequests, private r_u: RequestUrls, private router: Router) {
    }

    ngOnInit() {
        this.domainCheck();
    }

    private domainCheck() {
        this.c_f.setLoading(true);
        const url = this.r_u.getUrl('domain_check');
        this.h_r.HttpGet(url).subscribe(response => {
            if (response.status && response.domain) {
                this.c_f.setLoading(false);
                DataSharing.StoreJsonObj('settings', response.data);
                DataSharing.StoreJsonObj('level_info', response.data.level_info);
                this.LoginCheck();
            } else {
                this.c_f.setLoading(false);
                this.c_f.ShowToast(response.message, 'danger');
                // window.location.href = this.c_f.fmsBaseUrl();
            }
        }, err => {
            this.c_f.setLoading(false);
            this.c_f.ShowToast(err.message, 'danger');
        });
    }

    private LoginCheck() {
        const url = this.r_u.getUrl('auth_check');
        this.h_r.HttpGet(url).subscribe(response => {
            if (response.status) {
                DataSharing.StoreJsonObj('info', response.data.info);
                DataSharing.StoreJsonObj('settings', response.data.settings);
                DataSharing.StoreJsonObj('level_info', response.data.level_info);
            } else {
                DataSharing.clearAll();
                this.c_f.ShowToast(response.message, 'danger');
                this.router.navigate(['login']);
            }
        });
    }
}
